import { Card } from "antd";
import React from "react";
import {useNavigate} from "react-router-dom";

export interface Props {
    label: string;
    icon: any;
    url: string;
    ukryj?: any;
}

const Kafelek = ({label, icon, url, ukryj}: Props) => {
    const navigate = useNavigate();

    if(ukryj){
        return null;
    }

    return (
        <Card
            hoverable
            style={{ width: 240 }}
            onClick={() => navigate(url)}
        >
            <b>{icon} {label}</b>
        </Card>
    )
}

export default Kafelek;
